import { apiProfile } from "@/api/axios-instance";
import { apiResponseMiddleware } from "@/middleware/api-response";
import toast from "react-hot-toast";

// interface ManagerType {
//   id: number;
//   fullName: string;
//   imageUrl?: string;
//   email?: string;
//   phone?: string;
//   positionTitle?: string;
// }

export interface OrganizationRoleType {
  roleId: number;
  roleName: string;
  roleDescription?: string;
  professorId?: number;
  professorFullName?: string;
  professorImageUrl?: string;
}

export interface OrganizationType {
  id: string;
  imageUrl: string;
  iconImageUrl: string;
  filterTypeUnits: number;
  title: string;
  faculityTitle: string;
  website: string | null;
  description: string;
  bannerDescription: string;
  establishmentYear: string;
  opacity: string;
  backgroundColor: string | null;
  childs: any | null;
  organizationRoles?: OrganizationRoleType[];
}

export interface OrganizationResponse {
  data: OrganizationType;
  message: string;
  status: boolean;
  statusCode: number;
  totalCount: number;
  listSize: number;
  listNumber: number;
}

export const getOrganization = async (unitName: string, language: number = 0): Promise<OrganizationType> => {
  const response = await apiResponseMiddleware<OrganizationType>(
    apiProfile.get(`/api/Organization/GetOrganization/${unitName}?Language=${language}`),
    () => { },
    {
      showToast: false
    }
  );

  return response?.data || {} as OrganizationType;
};

export interface RoleToUpdate {
  roleId: number;
  userId: number;
}

export interface EditOrganizationType {
  unitId?: string;
  title?: string;
  titleFa?: string;
  unitIdentifier?: string;
  image?: string;
  iconImage?: string;
  descriptionEn?: string;
  descriptionFa?: string;
  bannerDescriptionEn?: string;
  bannerDescriptionFa?: string;
  website?: string;
  backgroundColor?: string;
  establishmentYear?: number;
  opacity?: string;
  roleToUpdates?: RoleToUpdate[];
  facultyId?: number | null;
}

export const editOrganization = async (id: string, data: EditOrganizationType) => {
  return await apiResponseMiddleware<OrganizationType>(
    apiProfile.post(`/api/Organization/UpdateOrganization/${id}`, data),
    () => {
      toast.success("اطلاعات سازمان با موفقیت ذخیره شد", {
        id: "api-middleware"
      });
    },
    {
      showToast: true,
      loadingMessage: "در حال ذخیره اطلاعات سازمان"
    }
  );
};

export const uploadUnitImage = async (
  unitId: string,
  file: File
): Promise<{ imageUrl: string } | null> => {
  const formData = new FormData();
  formData.append("image", file);
  const response = await apiResponseMiddleware<{ imageUrl: string }>(
    apiProfile.post(`/api/Organization/UploadOrganizationImage/${unitId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    }),
    () => { },
    { showToast: false }
  );
  return response?.data ?? null;
};